export default [
  {
    path: '/transactions',
    name: 'TransactionList',
    component: () => import(/* webpackChunkName: "banks" */ '@/views/bank/TransactionList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      legacyTitle: 'Transferencias',
      title: 'Conciliación'
    }
  }
]